<template>
  <div class="max-w-2xl mx-auto px-8 dark:bg-gray-900 dark:text-gray-300">
    <p class="font-display text-4xl text-center leading-none">
      {{ name }}
    </p>
    <p class="text-gray-500 text-sm mt-4 text-center">{{ desc }}</p>

    <!-- Social -->
    <div class="mt-6 flex justify-center space-x-1 rtl:space-x-reverse">
      <BizSocialLink
        v-for="icon in socialLink"
        :key="`social-${icon.id}`"
        :platform="icon.platform"
        :href="icon.url"
        :title="icon.title"
        target="_blank"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "pinia";
import { useBizStore } from "@/store/index.js";
export default {
  computed: {
    ...mapState(useBizStore, ["desc", "name", "socialLink"]),
  },
};
</script>
